/* Naturealm Tools: Label checker */
(function () {
  var root = document.querySelector('[data-lc]');
  if (!root) return;

  var qs = Array.prototype.slice.call(root.querySelectorAll('[data-lc-q]'));
  var quiz = root.querySelector('[data-lc-quiz]');
  var result = root.querySelector('[data-lc-result]');
  var bar = root.querySelector('[data-lc-bar]');
  var stepEl = root.querySelector('[data-lc-step]');
  var nav = root.querySelector('[data-lc-nav]');
  var back = root.querySelector('[data-lc-back]');
  var total = qs.length;
  var answers = [];
  var current = 0;

  var LABELS = {
    pass: 'Passes',
    fail: 'Misses',
    unsure: 'Unclear'
  };
  var VERDICTS = [
    { min: 5, title: 'Your supplement passes every check.', note: 'That is a well-made label. If it is working for you, keep it.' },
    { min: 3, title: 'Solid, with a few gaps worth asking about.', note: 'Email the brand about the checks it missed or left unclear. A good brand answers fast.' },
    { min: 0, title: 'Worth a second look.', note: 'Several checks are missing or unclear. You may be paying for grain, filler, or less mushroom than you think.' }
  ];

  root.classList.add('is-stepper');

  function show(i) {
    current = i;
    qs.forEach(function (q, n) { q.classList.toggle('is-current', n === i); });
    if (bar) bar.style.width = ((i + 1) / total * 100) + '%';
    if (stepEl) stepEl.textContent = 'Check ' + (i + 1) + ' of ' + total;
    if (nav) nav.hidden = i === 0;
  }

  function finish() {
    var score = answers.filter(function (a) { return a.value === 'pass'; }).length;
    var v = VERDICTS.filter(function (x) { return score >= x.min; })[0];
    root.querySelector('[data-lc-verdict]').textContent = v.title;
    root.querySelector('[data-lc-score]').textContent = score;
    var unsure = answers.filter(function (a) { return a.value === 'unsure'; }).length;
    var note = v.note;
    if (score < 5 && unsure) note += ' Anything marked unclear is a fair question to ask before you reorder.';
    root.querySelector('[data-lc-note]').textContent = note;

    answers.forEach(function (a, i) {
      var cell = root.querySelector('[data-lc-row="' + i + '"] [data-lc-yours]');
      if (!cell) return;
      cell.innerHTML = '';
      var dot = document.createElement('span');
      dot.className = 'nt-dot nt-dot--' + a.value;
      dot.setAttribute('aria-hidden', 'true');
      var txt = document.createElement('span');
      txt.textContent = LABELS[a.value] + ' · ' + a.label;
      cell.appendChild(dot);
      cell.appendChild(txt);
    });

    quiz.hidden = true;
    result.hidden = false;
    result.focus({ preventScroll: true });
    var top = result.getBoundingClientRect().top + window.pageYOffset - 90;
    window.scrollTo({ top: top, behavior: 'smooth' });

    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'label_checker_complete', label_checker_score: score });
      if (window.klaviyo && window.klaviyo.push) window.klaviyo.push(['track', 'Used Label Checker', { score: score }]);
    } catch (e) {}
  }

  qs.forEach(function (q, i) {
    Array.prototype.forEach.call(q.querySelectorAll('.nt-answer'), function (btn) {
      btn.addEventListener('click', function () {
        Array.prototype.forEach.call(q.querySelectorAll('.nt-answer'), function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
        answers[i] = { value: btn.getAttribute('data-value'), label: btn.textContent.trim() };
        setTimeout(function () {
          if (i + 1 < total) {
            show(i + 1);
            var first = qs[i + 1].querySelector('.nt-answer[aria-pressed="true"]') || qs[i + 1].querySelector('.nt-answer');
            if (first) first.focus({ preventScroll: true });
          } else {
            finish();
          }
        }, 180);
      });
    });
  });

  if (back) back.addEventListener('click', function () { if (current > 0) show(current - 1); });

  var restart = root.querySelector('[data-lc-restart]');
  if (restart) restart.addEventListener('click', function () {
    answers = [];
    Array.prototype.forEach.call(root.querySelectorAll('.nt-answer'), function (b) { b.setAttribute('aria-pressed', 'false'); });
    result.hidden = true;
    quiz.hidden = false;
    show(0);
    var top = quiz.getBoundingClientRect().top + window.pageYOffset - 90;
    window.scrollTo({ top: top, behavior: 'smooth' });
  });

  show(0);
})();
